module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"form\" style=\"height: 100%; padding: 20px\">\n    <div class=\"table wh100 table-0-100\">\n        <div>\n            <div>\n                <div class=\"relative\">\n                    ")
    ;  if (widget.showTitle) { 
    ; __append("\n                        <div class=\"split form__bar\" name=\"form-header\">\n                            <div class=\"form-title\" name=\"form-title\">\n                                ")
    ; __append(escapeFn( widget.getTitle() ))
    ; __append("\n                            </div>\n                            ")
    ;  if (widget.showCloseBtn) { 
    ; __append("\n                                <div class=\"split__right\">\n                                    <span class=\"icon-close icon-24\" on-click=\"onCloseClick\"></span>\n                                </div>\n                            ")
    ;  } 
    ; __append("\n                            ")
    ;  if (widget.grid) { 
    ; __append("\n                                <div class=\"count\">\n                                    Записей: <span name=\"record-count\"></span>\n                                </div>\n                            ")
    ;  } 
    ; __append("\n                        </div>\n                    ")
    ;  } 
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div>\n            <div>\n                <div name=\"form-body\" class=\"wh100 relative\">\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}